import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Валидатор, который проверяет, что значение FormControl является непустым массивом
 * @returns ValidatorFn
 */
export function nonEmptyArrayValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    // Проверяем, что значение существует
    if (value == null) {
      return { nonEmptyArray: { message: 'errors.must-be-an-array' } };
    }

    // Проверяем, что значение является массивом
    if (!Array.isArray(value)) {
      return { nonEmptyArray: { message: 'errors.must-be-an-array' } };
    }

    // Проверяем, что массив не пустой
    if (value.length === 0) {
      return { nonEmptyArray: { message: 'errors.non-empty-array' } };
    }

    // Валидация пройдена
    return null;
  };
}

/**
 * Пример использования:
 *
 * import { Component } from '@angular/core';
 * import { FormControl, ReactiveFormsModule } from '@angular/forms';
 * import { nonEmptyArrayValidator } from './validators/non-empty-array.validator';
 *
 * @Component({
 *   selector: 'app-example',
 *   standalone: true,
 *   imports: [ReactiveFormsModule],
 *   template: `
 *     <div>
 *       <label>Выберите элементы:</label>
 *       @if (itemsControl.invalid && itemsControl.touched) {
 *         <div class="error">
 *           {{ itemsControl.errors?.['nonEmptyArray']?.message }}
 *         </div>
 *       }
 *     </div>
 *   `
 * })
 * export class ExampleComponent {
 *   itemsControl = new FormControl([], [nonEmptyArrayValidator()]);
 *
 *   constructor() {
 *     // Тестирование валидатора
 *     console.log(this.itemsControl.valid); // false (пустой массив)
 *
 *     this.itemsControl.setValue([1, 2, 3]);
 *     console.log(this.itemsControl.valid); // true (непустой массив)
 *
 *     this.itemsControl.setValue([]);
 *     console.log(this.itemsControl.valid); // false (пустой массив)
 *
 *     this.itemsControl.setValue(null);
 *     console.log(this.itemsControl.valid); // false (не массив)
 *   }
 * }
 */
